import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changePassword } from '../modules/update_customer_actions';
class PasswordReset extends Component {


  constructor(props) {
    super(props);
    this.state = {
      password: null,
      confirm_password: null,
      error: null
    };
    this.changePassword = this.changePassword.bind(this);
    this.onChange       = this.onChange.bind(this);
  }

  // TODO: validate password rules?
  changePassword(evt) {
    evt.preventDefault();

    if (this.state.password !== this.state.confirm_password) return this.setState({error: true});

    this.setState({ error: false });
    this.props.dispatch(changePassword(this.state.password));
  }

  onChange(evt) {
    let oNewState = {};
    oNewState[evt.target.name] = evt.target.value;
    this.setState(oNewState);
  }

  render() {
    return (
      <div className="content-max-width cms">
        <h1>Password Reset</h1>
        <div className={"errorMessage hidden " + (this.state.error ? 'showing' : '')}>
            <p>Your password entries do not match.</p>
        </div>
        <form>
          <label>Enter your new password here:</label>
          <input
            type="password"
            name="password"
            onChange={this.onChange}
          />
          <label>Confirm your new password:</label>
          <input
            type="password"
            name="confirm_password"
            onChange={this.onChange}
          />
          <button className="btn-primary" onClick={this.changePassword}>Submit</button>
        </form>
      </div>
    );
  }
}

export default connect()(PasswordReset);


// WEBPACK FOOTER //
// ./src/components/PasswordReset.jsx